import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { SprayEventEntityId } from 'services/sprayEvents/types';
import {
    selectEntities,
    makeSelectEntityPathNames
} from 'services/entities/selectors';
import { OwnProps } from './index';

const selectSpraySchemaEntityId = (
    state: AppState,
    props: OwnProps
): SprayEventEntityId => props.spraySchemaEntityId;

const selectEntityName = createDeepEqualSelector(
    makeSelectEntityPathNames(),
    selectSpraySchemaEntityId,
    selectEntities,
    (entityPathnames, spraySchemaEntityId, entities) => {
        const sprayEntityPathnames = get(entities, [
            spraySchemaEntityId,
            'pathNames'
        ]);

        if (entityPathnames) {
            return entityPathnames.replace(`${sprayEntityPathnames} / `, '');
        }

        return '';
    }
);

const makeSelectEntityName = (): typeof selectEntityName => selectEntityName;

export { selectSpraySchemaEntityId, makeSelectEntityName };
